'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\n  div.Select-control {\n    border: 1px solid ', ' !important;\n    border-radius: 5px !important;\n    height: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value {\n    color: ', ';\n    border: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-menu-outer {\n    border: none;\n    top: 45px;\n    z-index: 3;\n  }\n\n  div.Select-menu-outer div.Select-menu {\n    border: none;\n    box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option{\n    background-color: ', ';\n    color: ', ';\n    border-bottom: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option: hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n\n  div.Select-control {\n    border: 1px solid ', ' !important;\n    border-radius: 5px !important;\n    height: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value {\n    color: ', ';\n    border: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-menu-outer {\n    border: none;\n    top: 45px;\n    z-index: 3;\n  }\n\n  div.Select-menu-outer div.Select-menu {\n    border: none;\n    box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option{\n    background-color: ', ';\n    color: ', ';\n    border-bottom: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option: hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\n  div.Select-control {\n    border: 1px solid ', ' !important;\n    border-radius: 5px !important;\n    height: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value {\n    background-color: ', ';\n    color: ', ';\n    border: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value span.Select-value-icon {\n    border: 0px;\n    border-radius: 5px;\n    color: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value span.Select-value-icon:hover {\n    border: 0px;\n    background-color: ', ';\n    color: ', ';\n  }\n\n  div.Select-menu-outer {\n    border: none;\n    ', '\n    z-index: 3;\n  }\n\n  div.Select-menu-outer div.Select-menu {\n    border: none;\n    box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option{\n    background-color: ', ';\n    color: ', ';\n    border-bottom: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option: hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n\n  div.Select-control {\n    border: 1px solid ', ' !important;\n    border-radius: 5px !important;\n    height: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value {\n    background-color: ', ';\n    color: ', ';\n    border: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value span.Select-value-icon {\n    border: 0px;\n    border-radius: 5px;\n    color: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-value span.Select-value-icon:hover {\n    border: 0px;\n    background-color: ', ';\n    color: ', ';\n  }\n\n  div.Select-menu-outer {\n    border: none;\n    ', '\n    z-index: 3;\n  }\n\n  div.Select-menu-outer div.Select-menu {\n    border: none;\n    box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option{\n    background-color: ', ';\n    color: ', ';\n    border-bottom: 1px solid ', ';\n    border-radius: 5px;\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option: hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n\n  div.Select-control, div.Select-menu-outer {\n    border: none;\n    height: ', ';\n    box-shadow: none !important;\n\n    span.Select-multi-value-wrapper {\n      div.Select-placeholder{\n        line-height: 36px;\n      }\n    }\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-placeholder {\n    border: 1px solid ', ';\n    border-radius: 5px;\n    height: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-input input {\n    line-height: 0px;\n  }\n\n  div.Select-menu-outer {\n    position: absolute;\n    top: ', ';;\n    width: ', ';\n    min-width: ', ';\n    min-height: ', ';\n    z-index: 3;\n    width: 100%\n  }\n\n  div.Select-menu-outer div.Select-menu {\n    overflow-y: ', ';\n    min-height: ', ';\n    box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option {\n    padding-left: 20px;\n    padding-right: 20px;\n    white-space: nowrap;\n    overflow:hidden !important;\n    text-overflow: ellipsis;\n    text-align: left;\n  }\n\n  div.Select-menu-outer div.Select-menu div.is-selected {\n    background-color: ', ';\n    color: ', ';\n  }\n\n  div.Select-menu-outer div.Select-menu div.is-focused {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  width: ', ';\n  height: ', ';\n\n  div.Select-control, div.Select-menu-outer {\n    border: none;\n    height: ', ';\n    box-shadow: none !important;\n\n    span.Select-multi-value-wrapper {\n      div.Select-placeholder{\n        line-height: 36px;\n      }\n    }\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-placeholder {\n    border: 1px solid ', ';\n    border-radius: 5px;\n    height: ', ';\n  }\n\n  div.Select-control span.Select-multi-value-wrapper div.Select-input input {\n    line-height: 0px;\n  }\n\n  div.Select-menu-outer {\n    position: absolute;\n    top: ', ';;\n    width: ', ';\n    min-width: ', ';\n    min-height: ', ';\n    z-index: 3;\n    width: 100%\n  }\n\n  div.Select-menu-outer div.Select-menu {\n    overflow-y: ', ';\n    min-height: ', ';\n    box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  }\n\n  div.Select-menu-outer div.Select-menu div.Select-option {\n    padding-left: 20px;\n    padding-right: 20px;\n    white-space: nowrap;\n    overflow:hidden !important;\n    text-overflow: ellipsis;\n    text-align: left;\n  }\n\n  div.Select-menu-outer div.Select-menu div.is-selected {\n    background-color: ', ';\n    color: ', ';\n  }\n\n  div.Select-menu-outer div.Select-menu div.is-focused {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n  font-size: 14px;\n  height: ', ';\n\n  &:hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n  font-size: 14px;\n  height: ', ';\n\n  &:hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  border: 1px solid ', ';\n  border-radius: 5px;\n  height: ', ';\n  line-height: 0px !important;\n\n  span.Select-value-label {\n    line-height: ', ';\n    color: ', ' !important;\n  }\n'], ['\n  border: 1px solid ', ';\n  border-radius: 5px;\n  height: ', ';\n  line-height: 0px !important;\n\n  span.Select-value-label {\n    line-height: ', ';\n    color: ', ' !important;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CreatableStyledSelect = (0, _styledComponents2.default)(_reactSelect.Creatable)(_templateObject, _color2.default.blue_accent, function (props) {
  return props.height ? props.height : 'auto';
}, _color2.default.grey_main, _color2.default.white, _color2.default.purple_accent, _color2.default.blue_main, _color2.default.white, _color2.default.blue_main, _color2.default.white);

var MultipleStyledSelect = (0, _styledComponents2.default)(_reactSelect2.default)(_templateObject2, _color2.default.blue_accent, function (props) {
  return props.height ? props.height : 'auto';
}, _color2.default.purple_accent, _color2.default.grey_main, _color2.default.white, _color2.default.blue_main, _color2.default.blue_accent, _color2.default.white, '' /* top: 45px; */, _color2.default.purple_accent, _color2.default.blue_main, _color2.default.white, _color2.default.blue_accent, _color2.default.white);

var SingleStyledSelect = (0, _styledComponents2.default)(_reactSelect2.default)(_templateObject3, function (props) {
  return props.width ? props.width : 'auto';
}, function (props) {
  return props.height ? props.height : 'auto';
}, function (props) {
  return props.height ? props.height : 'auto';
}, _color2.default.blue_accent, function (props) {
  return props.height ? props.height : 'auto';
}, function (props) {
  return props.optionContatinerTop ? props.optionContatinerTop : '45px';
}, function (props) {
  return props.optionContatinerWidth ? props.optionContatinerWidth : 'auto';
}, function (props) {
  return props.optionContatinerWidth ? props.optionContatinerWidth : '200px';
}, function (props) {
  return props.optionContatinerHeight ? props.optionContatinerHeight : 'auto';
}, function (props) {
  return props.scrollBar ? 'auto' : 'inherit';
}, function (props) {
  return props.optionContatinerHeight ? props.optionContatinerHeight : 'auto';
}, _color2.default.blue_main, _color2.default.white, _color2.default.blue_accent, _color2.default.white);

var OptionDiv = _styledComponents2.default.div(_templateObject4, _color2.default.purple_accent, _color2.default.blue_main, function (props) {
  return props.height ? props.height : 'auto';
}, _color2.default.grey_accent_1, _color2.default.white);

var ValueDiv = _styledComponents2.default.div(_templateObject5, _color2.default.blue_accent, function (props) {
  return props.height ? props.height : 'auto';
}, function (props) {
  return props.height ? props.height : '36px';
}, _color2.default.grey_main);

var AngleDown = _styledComponents2.default.span(_templateObject6, _color2.default.blue_accent);

var MozartSelectField = function (_Component) {
  _inherits(MozartSelectField, _Component);

  function MozartSelectField(props) {
    _classCallCheck(this, MozartSelectField);

    var _this = _possibleConstructorReturn(this, (MozartSelectField.__proto__ || Object.getPrototypeOf(MozartSelectField)).call(this, props));

    _this.state = {
      value: props.defaultValue ? props.defaultValue : null
    };
    return _this;
  }

  _createClass(MozartSelectField, [{
    key: 'onChange',
    value: function onChange(selectedValue) {
      var value = selectedValue ? selectedValue : 1;
      var selected = this.props.data ? this.props.data.filter(function (item) {
        return item.value === selectedValue;
      }) : [];
      var tagsLength = value.length - 1;
      if (value.length > 0 && this.props.emailValidation) {
        var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRegex.test(value[tagsLength].value)) {
          this.props.onChange(value, selected);
          this.setState({ value: value });
        } else {
          value.splice(tagsLength, 1);
          this.setState({ value: value });
        }
      } else {
        this.props.onChange(value, selected);
        this.setState({ value: value });
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions(data) {
      var DATA = [];
      if (data && data.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var value = item.value ? item.value : item.id;
            var label = item.text ? item.text : item.name;
            var disabled = item.disabled !== undefined && item.disabled ? item.disabled : false;
            var customValue = item.customValue !== undefined && item.customValue ? item.customValue : false;
            DATA.push({
              value: value,
              label: label,
              disabled: disabled,
              customValue: customValue,
              firstItem: false,
              lastItem: false
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        DATA[0].firstItem = true;
        DATA[DATA.length - 1].lastItem = true;
      }
      return DATA;
    }
  }, {
    key: 'arrowRenderer',
    value: function arrowRenderer() {
      return _react2.default.createElement(AngleDown, { className: 'icon-Down' });
    }
  }, {
    key: 'valueComponent',
    value: function valueComponent(props) {
      var height = this.props.height;

      return _react2.default.createElement(
        ValueDiv,
        { height: height, className: 'Select-value', title: props.value.title },
        _react2.default.createElement(
          'span',
          { className: 'Select-value-label' },
          props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          scrollBar = _props.scrollBar,
          clearable = _props.clearable,
          disabled = _props.disabled,
          searchable = _props.searchable,
          multi = _props.multi,
          hintText = _props.hintText,
          autoWidth = _props.autoWidth,
          data = _props.data,
          multiselect = _props.multiselect,
          custom = _props.custom,
          customClassName = _props.customClassName,
          allowCreate = _props.allowCreate,
          width = _props.width,
          height = _props.height,
          optionContatinerTop = _props.optionContatinerTop,
          optionContatinerHeight = _props.optionContatinerHeight,
          optionContatinerWidth = _props.optionContatinerWidth,
          themeId = _props.themeId;

      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        !multiselect && !custom && !allowCreate && _react2.default.createElement(SingleStyledSelect, {
          scrollBar: scrollBar,
          arrowRenderer: this.arrowRenderer,
          autoFocus: true,
          options: this.getOptions(data),
          simpleValue: true,
          clearable: clearable,
          name: 'form-field-name',
          disabled: disabled,
          value: this.state.value,
          searchable: searchable,
          optionComponent: OptionComponent,
          valueComponent: this.valueComponent.bind(this),
          style: style,
          hintText: hintText,
          placeholder: hintText,
          onChange: this.onChange.bind(this),
          autoWidth: autoWidth,
          width: width,
          height: height,
          optionContatinerTop: optionContatinerTop,
          optionContatinerHeight: optionContatinerHeight,
          optionContatinerWidth: optionContatinerWidth
        }),
        multiselect && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(MultipleStyledSelect, {
            arrowRenderer: this.arrowRenderer,
            autosize: false,
            disabled: disabled,
            name: 'form-field-name',
            multi: true,
            joinValues: true,
            height: height,
            value: this.state.value,
            simpleValue: false,
            placeholder: hintText,
            options: this.getOptions(data),
            onChange: this.onChange.bind(this),
            className: customClassName,
            clearable: false
          })
        ),
        custom && _react2.default.createElement(SingleStyledSelect, {
          scrollBar: scrollBar,
          arrowRenderer: this.arrowRenderer,
          options: this.getOptions(data),
          placeholder: hintText,
          className: customClassName,
          clearable: false,
          name: 'form-field-name',
          disabled: disabled,
          height: height,
          value: this.state.value,
          optionComponent: OptionComponent,
          valueComponent: this.valueComponent.bind(this),
          onChange: this.onChange.bind(this) }),
        allowCreate && _react2.default.createElement(CreatableStyledSelect, {
          arrowRenderer: this.arrowRenderer,
          multi: multi,
          disabled: disabled,
          clearable: false,
          options: this.getOptions(data),
          name: 'form-field-name',
          height: height,
          value: this.state.value,
          placeholder: hintText,
          onChange: this.onChange.bind(this),
          className: customClassName,
          promptTextCreator: function promptTextCreator(label) {
            return label + ' ';
          } })
      );
    }
  }]);

  return MozartSelectField;
}(_react.Component);

MozartSelectField.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** turn search on */
  searchable: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  clearable: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.number]),
  hintText: _propTypes2.default.string,
  /** multiple select */
  multiselect: _propTypes2.default.bool,
  /** array of data (value, id, text) */
  data: _propTypes2.default.array.isRequired,
  /** if multiselect is false the value will be the id if multiselect true the value will be array of object */
  onChange: _propTypes2.default.func.isRequired,
  autoWidth: _propTypes2.default.bool,
  customClassName: _propTypes2.default.string,
  allowCreate: _propTypes2.default.bool,
  emailValidation: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  custom: _propTypes2.default.bool,
  dropdownClass: _propTypes2.default.string,
  multi: _propTypes2.default.bool,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  optionContatinerTop: _propTypes2.default.string,
  optionContatinerHeight: _propTypes2.default.string,
  optionContatinerWidth: _propTypes2.default.string,
  scrollBar: _propTypes2.default.bool
};
MozartSelectField.defaultProps = {
  searchable: true,
  disabled: false,
  clearable: false,
  hintText: '',
  multiselect: false,
  custom: false,
  allowCreate: false,
  emailValidation: false,
  multi: false,
  width: 'auto',
  scrollBar: true,
  height: '40px',
  testId: 'MozartSelectField',
  themeId: 'MozartSelectField'
};
exports.default = MozartSelectField;

var OptionComponent = function (_Component2) {
  _inherits(OptionComponent, _Component2);

  function OptionComponent() {
    _classCallCheck(this, OptionComponent);

    return _possibleConstructorReturn(this, (OptionComponent.__proto__ || Object.getPrototypeOf(OptionComponent)).apply(this, arguments));
  }

  _createClass(OptionComponent, [{
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      if (!this.props.option.disabled) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
      }
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(event) {
      this.props.onFocus(this.props.option, event);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (this.props.isFocused) return;
      this.props.onFocus(this.props.option, event);
    }
  }, {
    key: 'render',
    value: function render() {
      var optionValue = parseInt(this.props.option.value, 10);
      var borderColor = this.props.option.lastItem || optionValue % 2 === 1 ? '1px solid ' + _color2.default.white : '1px solid ' + _color2.default.blue_accent;
      var borderRadius = this.props.option.lastItem || this.props.option.firstItem ? '5px' : '0px';

      return _react2.default.createElement(
        OptionDiv,
        {
          'data-qa': this.props.testId,
          style: { borderBottom: borderColor, borderRadius: borderRadius },
          className: this.props.className,
          onMouseDown: this.handleMouseDown.bind(this),
          onMouseEnter: this.handleMouseEnter.bind(this),
          onMouseMove: this.handleMouseMove.bind(this),
          title: this.props.option.title,
          'data-theme': this.props.themeId },
        this.props.children
      );
    }
  }]);

  return OptionComponent;
}(_react.Component);

OptionComponent.PropTypes = {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDropDown/MozartSelectField/MozartSelectField.js
// module id = 717
// module chunks = 1